<template>
	<div>
		<waiting v-if="loaded.class == false || loaded.list == false" />
		<MenuClassList v-if="loaded.class" :items="items.class" @modifyItem="modifyItemByClass" @deleteItem="deleteItemByClass" />
		<MenuList v-if="loaded.list" :items="items.list" @modifyItem="modifyItemByList" @deleteItem="deleteItemByList" />
	</div>
</template>

<script>
	export default {
		name: 'MenuManager',
		props: {},
		data: () => ({
			items: {
				list: {
					level1: [],
					level2: [],
					level3: [],
				},
				class: {
					level1: [],
					level2: [],
					level3: [],
				},
			},
			loaded: { list: false, class: false },
			unsubscribeItems: { list: null, class: { level1: null, level2: null, level3: null } },
		}),
		mounted: async function() {
			this.loadItemsByList();
			this.loadItemsByClass();
		},
		methods: {
			async loadItemsByList() {
				// 데이터베이스 변동 여부 확인 :: S
				if (this.unsubscribeItems.list != null) {
					this.unsubscribeItems.list();
				}
				this.unsubscribeItems.list = this.$database.onTreatments(async () => {
					this.loaded.list = false;
					this.items.list.level1 = await this.$database.loadTreatments(1);
					this.items.list.level2 = await this.$database.loadTreatments(2);
					this.items.list.level3 = await this.$database.loadTreatments(3);
					this.loaded.list = true;
				});

				// this.items.list.level1 = await this.$database.loadTreatments(1);
				// this.items.list.level2 = await this.$database.loadTreatments(2);
				// this.items.list.level3 = await this.$database.loadTreatments(3);
				// this.loaded.list = true;
				// 데이터베이스 변동 여부 확인 :: E
			},
			async loadItemsByClass() {
				// 데이터베이스 변동 여부 확인 :: S
				const levelKey = `level1`;

				// 기존 unsubscribe 처리
				if (this.unsubscribeItems.class[levelKey] != null) {
					this.unsubscribeItems.class[levelKey]();
				}

				// 새로운 구독 등록
				this.unsubscribeItems.class[levelKey] = this.$database.onTreatmentClassfications(async () => {
					this.loaded.class = false;
					this.items.class[levelKey] = await this.$database.loadTreatmentClassfications(1);
					// this.items.class[levelKey] = level === 1 ? await this.$database.loadTreatmentClassfications(level) : [];
					this.loaded.class = true;
				}, 1);
				// 데이터베이스 변동 여부 확인 :: E
			},
			async modifyItemByList({ items, item, isModify, level }) {
				// 메뉴 저장 (추가 또는 수정)
				if (isModify) {
					// 수정
					await this.$database.modifyTreatment(item);
				} else {
					const nextCode = await this.$database.loadNextCode(level);

					item.level = level;
					item.code = nextCode;
					item.sort = items.length + 1;

					await this.$database.addTreatment(item);
				}
			},
			async deleteItemByList(item) {
				await this.$database.deleteTreatment(item.id);
			},
			async modifyItemByClass({ items, level }) {
				let sort = this.items.class[`level${level}`]?.length + 1;

				for (const item of items) {
					item.level = level;
					item.sort = sort++;

					// 비동기 처리 (데이터베이스에 항목 추가)
					await this.$database.addTreatmentClassfication(item);
				}

				// 항목을 리스트에 추가 (배열 복사 및 반응성 유지)
				// this.items.class[`level${level}`] = [...this.items.class[`level${level}`], ...items];
			},
			async deleteItemByClass({ item, level }) {
				await this.$database.deleteTreatmentClassfication(item.code, level);

				// // 해당 레벨에서 삭제할 항목의 레벨을 가져옴
				// const level = item.level;

				// console.log('level', level);
				// console.log('this.items.class[`level${level }`]', this.items.class[`level${level}`]);
				// console.log(this.items.class[`level${level}`].filter(i => i.id !== item.id));

				// // 항목을 배열에서 제거
				// this.items.class[`level${level}`] = this.items.class[`level${level}`].filter(i => i.id !== item.id);
			},
		},
	};
</script>

<style scoped></style>
